import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { Inquiry } from '@tv3/store/inquiry/inquiry.model'
import { AddHoldDialogComponent } from './add-hold-dialog.component'

@Injectable()
export class AddHoldDialogService {
  constructor(private dialog: MatDialog) {}

  open(inquiry?: Inquiry) {
    let event = '[Dialog] Add Hold'
    if (inquiry) {
      event = '[Dialog] Edit Hold'
    }
    const defaultConfig: MatDialogConfig = {
      width: '650px',
      height: 'auto',
      panelClass: ['fixed-modal'],
      data: { inquiry },
    }

    return this.dialog.open(AddHoldDialogComponent, defaultConfig)
  }

  openCreateHoldEvent(start?: number, end?: number, rentalId?: string) {
    let inquiry = null

    if (start || end || rentalId) {
      inquiry = new Inquiry({
        guestArrive: start,
        guestDepart: end,
        rentalId,
      })
    }

    return this.open(inquiry)
  }
}
